export default __webpack_public_path__ + "static/media/debate_23.80d1175f.JPG";